<template>
  <div class="left-chart-3" id="left-chart-3"></div>
</template>

<script>
import { selectInspectProfitMr } from '@/api/modules/dataView.js'
export default {
  name: 'LeftChart3',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const echartsDom = document.getElementById('left-chart-3')
      this.chart = this.$echarts.init(echartsDom)
      const apiData = await selectInspectProfitMr(this.date)
      const echartsData = []
      if (apiData) {
        apiData.forEach(item => {
          echartsData.push({
            name: item.hxcs_position,
            value: item.money || 0,
          })
        })
      }
      const options = {
        title: {
          text: '部位检查收益情况',
          left: 'center',
          top: '10px',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {},
        legend: {
          type: 'scroll',
          pageIconColor: '#70f3ff',
          pageIconInactiveColor: '#065279',
          bottom: 10,
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          bottom: 10,
        },
        series: [
          {
            name: '收益（元）',
            type: 'pie',
            radius: ['40%', '60%'],
            label: {
              formatter: function(data) {
                return data.percent.toFixed(0) + '%'
              },
              show: true,
              textStyle: {
                color: '#fff',
              },
              position: 'inner',
            },
            insideLabel: {
              show: true,
            },
            labelLine: {
              show: false,
            },
            data: echartsData,
          },
        ],
      }
      this.chart.setOption(options)
    },
  },
}
</script>

<style lang="scss">
.left-chart-3 {
  width: 100%;
  height: 33%;
  display: flex;
  flex-direction: column;
}
</style>
